import React, { useContext } from "react"
import SiteContext from "../../context/site-context"
import { getPartners } from "../../lib/call-api"
import { Swiper, SwiperSlide } from 'swiper/react'

import SwiperCore, { Navigation, A11y, Autoplay } from 'swiper';

//import 'swiper/swiper-bundle.min.css'
import './partners.scss'
SwiperCore.use([Navigation, A11y, Autoplay]);



export default function Partners() {

  const { partnersState, partnersSetState } = useContext(SiteContext)

   React.useEffect(() => {
      getPartners().then(responce => {
         //console.log('Partners responce', responce);
         if (responce === undefined) {
            partnersSetState([]);
         } else if (responce.status !== 200) {
            partnersSetState([]);
         } else {
            partnersSetState(responce.data)
         }
      })
   }, [])

  return (

    <div className="partners-section">
      <div className="push60"></div>

      <div className="container">
        <div className="text-center">

          <div className="title-h1 white bold">Наши партнеры</div>


          <div className="subtitle-h1">
            Дальнейшее развитие различных форм деятельности нашей компании требуют от нас постоянного анализа направлений <br />
            прогрессивного развития, а также тесного сотрудничества с ключевыми игроками на рынке. <br />
            Поэтому, наша команда всегда открыта к новым изменениям и сотрудничеству!
          </div>

        </div>
        <div className="push10"></div>
        <div className="bottom-slider">

          <Swiper
            spaceBetween={0}
            slidesPerView={2}
            navigation
            loop={true}
            speed={1000}
            autoplay={true}
            breakpoints={{
              // 260: {
              //   slidesPerView: 2,
              // },
              460: {
                slidesPerView: 3,
              },
              700: {
                slidesPerView: 4,
              },
              992: {
                slidesPerView: 5,
              },
              1350: {
                slidesPerView: 6,
              }
            }}
          >
            {partnersState.map((item) => (
              <SwiperSlide key={item.id}>


                <div className='element'>
                  <div className="img-wrapper">
                    <img src={item.image} alt={item.name} />
                  </div>
                </div>
              </SwiperSlide>
            ))}


          </Swiper>

        </div>
      </div>

      <div className="push80"></div>
    </div>

  )
}